var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":"System info"}},[_c('v-row',[_c('v-col',[_c('div',[_c('p',{staticClass:"headline"},[_vm._v(" process.env ")]),_c('code',[_c('pre',[_vm._v(_vm._s(_vm.processEnv))])])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }